<template>
  <div v-if="!!type">
    <QS-h4-title title="维保图片" />
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item  :label="'进厂照片'+columnSeparator">
        <UploadCommon
            :fileList="form.enterFactoryPictures"
            :isAlone="false"
            :isShowCustom="false"
            :limit="20"
            :sizeType="4"
            commonUpload
            group="assert"
            code="assert_enter_factory_pic"
            multiple
          />
      </el-form-item>
      <el-form-item  :label="'维修更换部件照片'+columnSeparator" v-if="type!==2">
        <UploadCommon
            :fileList="form.maintenancePictures"
            :isAlone="false"
            :isShowCustom="false"
            :limit="20"
            :sizeType="4"
            commonUpload
            group="assert"
            code="assert_maintenance_part_pic"
            multiple
          />
      </el-form-item>
      <el-form-item  :label="'事故现场图片'+ columnSeparator" v-if="type===4">
        <UploadCommon
            :fileList="form.accidentScenePictures"
            :isAlone="false"
            :isShowCustom="false"
            :limit="3"
            :sizeType="4"
            commonUpload
            group="assert"
            code="assert_accident_scene_pic"
            multiple
          />
      </el-form-item>
      <el-form-item  :label="'责任认定书图片'+columnSeparator" v-if="type===4">
        <UploadCommon
            :fileList="form.responsibilityPictures"
            :isAlone="false"
            :isShowCustom="false"
            :limit="3"
            :sizeType="4"
            commonUpload
            group="assert"
            code="assert_responsibility_pic"
            multiple
          />
      </el-form-item>
      <el-form-item  :label="'定损单图片'+columnSeparator" v-if="type===4">
        <UploadCommon
            :fileList="form.lossOrderPictures"
            :isAlone="false"
            :isShowCustom="false"
            :limit="3"
            :sizeType="4"
            commonUpload
            group="assert"
            code="assert_loss_order_pic"
            multiple
          />
      </el-form-item>
  </el-form>
  </div>

</template>
<script>
export default {
  name: 'addPhoto',
  props: ['type'],
  data() {
    return {
      form: {
        enterFactoryPictures: [],
        maintenancePictures: [],
        accidentScenePictures: [],
        responsibilityPictures: [],
        lossOrderPictures: [],
      },
    }
  },
}
</script>

<style>

</style>
